import styled from "styled-components";
import AvatarBg from "../../images/avatar-bg.png";
export const UserInfoWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0 50px;
  margin-top: 25px;
`;
export const UserInfoLeftWrapper = styled.div`
  display: flex;
  pointer-events: auto;
`;
export const UserInfoRightWrapper = styled.div`
  display: flex;
  align-items: center;
`;
export const AvatarIcon = styled.div`
  width: 54px;
  height: 54px;
  font-size: 30px;
  border-radius: 50%;
  text-align: center;
  font-weight: bold;
  margin-right: 8px;
  background-image: url(${AvatarBg});
  display: flex;
  align-items: center;
  justify-content: center;
  div {
    width: 44px;
    height: 44px;
    line-height: 44px;
    border-radius: 50%;
  }
`;
export const UserMemberWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
export const UserMemberInfo = styled.div`
  color: ${(p) => p.theme["color-text-1"]};
  font-size: 18px;
  font-weight: 600;
  display: flex;
`;
export const UserMemberExpired = styled.div`
  margin-top: 5px;
  color: ${(p) => p.theme["color-text-1"]};
  font-size: 12px;
`;

export const UserInfoContent = styled.div`
  display: flex;
  flex-wrap: nowrap;
`;
export const MemberIcon = styled.div<{ isMember?: number }>`
  border-radius: 28px;
  background: #fff;
  width: 90px;
  height: 20px;
  display: flex;
  align-items: center;
  color: ${({ isMember }) => (isMember === 1 ? "#4083FF" : "#8D8F9F")};
  font-size: 12px;
  font-weight: 500;
  justify-content: center;
  margin-left: 5px;
  span {
    margin-left: 2px;
  }
`;
export const UserAccountWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: 40px;
`;
export const UserAccountBalance = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 60px;
`;

export const UserAccountCredit = styled.div`
  display: flex;
  flex-direction: column;
`;
export const CreditLabel = styled.span`
  color: ${(p) => p.theme["color-text-1"]};
  font-size: 12px;
`;
export const CreditValue = styled.span``;
export const Separator = styled.span<{ height?: number }>`
  width: 1px;
  background: rgba(47, 75, 157, 0.4);
  margin: 0 6px;
  display: inline-block;
  height: ${(props) => props.height || "8"}px;
`;
export const CurrencySymbol = styled.span`
  color: ${(p) => p.theme["color-text-1"]};
  font-size: 12px;
  font-weight: 600;
`;
export const CurrencyNumber = styled.span`
  color: ${(p) => p.theme["color-text-1"]};
  font-size: 24px;
  font-weight: 600;
`;
export const JoinMembershipButton = styled.div`
  cursor: pointer;
  width: 122px;
  height: 30px;
  border-radius: 30px;
  background: #ffffff;
  text-align: center;
  line-height: 30px;
  font-weight: 600;
  @keyframes text {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }
  span {
    background: conic-gradient(
      from 180.33deg at 50.35% 38.24%,
      #42b0ff 0deg,
      #4a88ff 118.21deg,
      #42b0ff 360deg
    );
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    animation: text 4s infinite linear;
    color: transparent;
    background-size: 300% 100%;
  }
  &:hover {
    background: #f3feff;
  }
  &:active {
    background: #effeff;
  }
`;
